import { useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./CustomLink.js"

export default function QuillEditor({ value, onChange,placeholder }) {
  const quillRef = useRef();

  const modules = {
    toolbar: [
      ["bold", "italic", "underline"],
      ["link"], // use built-in button
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
    ],
    customLink: true, // enable the new module
  };

  return (
    <ReactQuill
      ref={quillRef}
      value={value}
      onChange={onChange}
      modules={modules}
      theme="snow"
      placeholder={placeholder}
      style={{maxWidth:'750px'}}
    />
  );
}